<header class="page-header">
	<h2>Integrations</h2>
</header>

<div class="grid grid-cols-4 gap-6">
	<ul class="col-span-1 flex flex-col row-span-full h-full mt-10">
		<li>
			<ng-container
				*ngTemplateOutlet="
					listItemButton;
					context: { integrationTypeKey: null, label: 'All' }
				"
			/>
		</li>
		<li
			*ngFor="
				let integrationType of integrationsMap
					| keyvalue: keyValuePipeComparator
			"
		>
			<ng-container
				*ngTemplateOutlet="
					listItemButton;
					context: {
						integrationTypeKey: integrationType.key,
						label: integrationType.key,
					}
				"
			/>
		</li>
	</ul>
	<div
		class="col-span-3 col-start-2 3xl:col-span-2 3xl:col-start-2"
		*ngFor="
			let integrationType of integrationsMap
				| keyvalue: keyValuePipeComparator
				| filterV2: currentFilter : currentFilterKey
		"
	>
		<h3 [id]="integrationType.key" class="mt-10 mb-5">
			{{ integrationType.key }}
		</h3>
		<div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
			<app-integration-card
				*ngFor="
					let integration of integrationType.value
						| async
						| keyvalue: keyValuePipeComparator
				"
				[integrationKey]="integration.key"
				[integration]="integration.value"
			/>
		</div>
	</div>
</div>

<ng-template
	#listItemButton
	let-integrationTypeKey="integrationTypeKey"
	let-label="label"
>
	<button
		class="p-4 text-sm text-gray-500 font-medium hover:text-green text-start"
		(click)="currentFilterKey = integrationTypeKey"
		[ngClass]="{
			'border-b border-green': currentFilterKey === integrationTypeKey,
		}"
		[testHook]="testHooks.Button"
	>
		{{ label }}
	</button>
</ng-template>
